import React from "react";
import ReactDOM from "react-dom/client";
import { Navigate, Route, Routes, HashRouter } from "react-router-dom";
import App from "./components/app";
import { dashboardroutes } from "./routing/dashboard";
import Network from "./components/dashboard/network";
import Login from "./components/login/login";

const Root = () => {
  return (
    <HashRouter>
      <Network />
      
      <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" exact={true} element={<Login />} />

        <Route element={<App />}>
          {dashboardroutes.map((route) => (
            <Route
              key={route.id}
              exact={route.exact}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
      </Routes>
    </HashRouter>

   
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
